jQuery.createEventCapturing = (function () {
    var special = jQuery.event.special;
    return function (names) {
        if (!document.addEventListener) {
            return;
        }
        if (typeof names == 'string') {
            names = [names];
        }
        jQuery.each(names, function (i, name) {
            var handler = function (e) {
                e = jQuery.event.fix(e);

                return jQuery.event.dispatch.call(this, e);
            };
            special[name] = special[name] || {};
            if (special[name].setup || special[name].teardown) {
                return;
            }
            jQuery.extend(special[name], {
                setup: function () {
                    this.addEventListener(name, handler, true);
                },
                teardown: function () {
                    this.removeEventListener(name, handler, true);
                }
            });
        });
    };
})();

jQuery.createEventCapturing(['play']);


$.fn.extend({
    autoHeight: function (options) {
        function autoHeight_(element) {
            var defaults = {
                minheight: 0,
                maxHeight: 9999
            };

            var settings = $.extend({}, defaults, options);

            var height = Math.max(element.scrollHeight, settings.minheight);
            height = Math.min(height, settings.maxHeight);


            return jQuery(element)
                .css({ 'height': 'auto', 'overflow-y': 'hidden' })
                .css("height", height + "px");
        }

        return this.each(function () {
            autoHeight_(this).on('input', function () {
                autoHeight_(this);
            });
        });
    }
    
});

jQuery.extend({
    padLeft: function (str, pad) {
        return pad.substring(0, pad.length - str.length) + str;
    }
});


$.fn.isInViewport = function (offset) {
    offset = offset || 0;

    if (this.length === 0) {
        if (__IsDevelopment) {
            console.log("isInViewport: object not found");
        }

        return;
    }

    var elementTop = $(this).offset().top + offset;
    var elementBottom = elementTop + $(this).outerHeight() + offset;

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

$.fn.findById = function (id, child) {
    if (child === null || typeof child === "undefined") {
        return this.filter("[data-id='{0}']".format(id));
    } else {
        return this.find(child + "[data-id='{0}']".format(id));
    }


};

$.fn.cssAnimate = function (effect, infinite, delay) {
    var $this = this;
    effect = effect || "bounce";
    infinite = infinite || "";
    delay = delay || "0";

    var animateClass = "animated {0} {1} delay-{2}s".format(effect, infinite, delay);
    $this.addClass(animateClass);

    setTimeout(function () { $this.removeClass(animateClass); }, 3000);
};

// Returns a function, that, when invoked, will only be triggered at most once
// during a given window of time. Normally, the throttled function will run
// as much as it can, without ever going more than once per `wait` duration;
// but if you'd like to disable the execution on the leading edge, pass
// `{leading: false}`. To disable execution on the trailing edge, ditto.
$.throttle = function throttle(wait, func) {
    var time = Date.now();
    return function () {
        if (time + wait - Date.now() < 0) {
            func();
            time = Date.now();
        }
    };
};

Date.prototype.Add = function (interval, units) {
    var ret = this; //don't change original date
    var checkRollover = function () { if (ret.getDate() !== date.getDate()) ret.setDate(0); };
    switch (interval.toLowerCase()) {
        case 'y': ret.setFullYear(ret.getFullYear() + units); checkRollover(); break;
        case 'q': ret.setMonth(ret.getMonth() + 3 * units); checkRollover(); break;
        case 'm': ret.setMonth(ret.getMonth() + units); checkRollover(); break;
        case 'w': ret.setDate(ret.getDate() + 7 * units); break;
        case 'd': ret.setDate(ret.getDate() + units); break;
        case 'h': ret.setTime(ret.getTime() + units * 3600000); break;
        case 'mm': ret.setTime(ret.getTime() + units * 60000); break;
        case 's': ret.setTime(ret.getTime() + units * 1000); break;
        default: ret = undefined; break;
    }
    return ret;
};

String.prototype.toInternationalDate = String.prototype.f = function () {
    var d = this;
    var nd = d.substr(6, 4) + "-" + d.substr(3, 2) + "-" + d.substr(0, 2);
    return nd;
};

String.prototype.removeValue = String.prototype.f = function (value, separator) {
    var list = this;
    separator = separator || ",";
    var values = list.split(separator);
    for (var i = 0; i < values.length; i++) {
        if (values[i].trim() === value.trim()) {
            values.splice(i, 1);
            return values.join(separator);
        }
    }
    return list;
};

String.prototype.Capitalize = String.prototype.f = function () {
    var s = this;
    return s.charAt(0).toUpperCase() + s.slice(1);;
};

Array.prototype.coalesce = function () {
    var len = this.length;
    for (var i = 0; i < len; i++) {
        if (this[i] !== null && this[i] !== undefined && this[i].length !== 0) {
            return this[i];
        }
    }
    return null;
};

// String Format: "{0}".format(["a"]);
String.prototype.format = String.prototype.f = function () {
    var s = this,
        i = arguments.length;

    while (i--) {
        s = s.replace(new RegExp('\\{' + i + '\\}', 'gm'), arguments[i]);
    }
    return s;
};

/* JQuery */

$.fn.serializeObject = function (avoidPropertyNamePart) {
    var o = {};
    var a = this.serializeArray();
   
    $.each(a, function () {

        var name = this.name;

    
        if (!$.isNull(avoidPropertyNamePart)) {
            name = name.replace(avoidPropertyNamePart, '');
        }

        if (o[name] !== undefined) {
            if (!o[name].push) {
                o[name] = [o[name]];
            }
            o[name].push(this.value || '');
        } else {
            o[name] = this.value || '';
        }
    });

    $(this).find('[disabled="disabled"]').each(function () {
        o[name] = this.value;
    });

    return o;
};

$.fn.attributesFillWith = function (data) {
    var $this = $(this);

    $.each(data, function (k, v) {
        $this.attr("data-" + k, v);
    });
};

$.fn.formFillWith = function (data) {
    var $this = $(this);

    $.each(data, function (k, v) {
      
        var $elem = $this.find('[name="{0}"]'.format(k));
        switch ($elem.prop("tagName")) {
            case "TEXTAREA":
                $elem
                    .text(v)
                    .val(v);                
                break;
            default:
                $elem.val(v);
        }
    });

};

function isFunction(functionToCheck) {
    return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
}

$.isNull = function (e) {
    if (typeof e === "undefined" || e === null) {
        return true;
    }
};

$.newGuid = function () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};

function dataId(elem, id) {
    return $(elem).attr("data-id") === id;
}

$.expr.pseudos.dataId = $.expr.createPseudo ?
    $.expr.createPseudo(function (text) {
        return function (elem) {
            return $(elem).attr("data-id") === text;
        };
    }) :
    function (elem, i, match) {
        return icontains(elem, match[3]);
    };

String.prototype.tagRemove = String.prototype.f = function () {
    var doc = new DOMParser().parseFromString(this, 'text/html');
    return doc.body.textContent || "";
};

String.prototype.FormatNumber = String.prototype.f = function (decPlaces, decSep, thouSep) {
    var number = this;
    decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces,
        decSep = typeof decSep === "undefined" ? "," : decSep;
    thouSep = typeof thouSep === "undefined" ? "." : thouSep;
    var sign = number < 0 ? "-" : "";
    var i = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(decPlaces)));
    var j = (j = i.length) > 3 ? j % 3 : 0;

    return sign +
        (j ? i.substr(0, j) + thouSep : "") +
        i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
        (decPlaces ? decSep + Math.abs(number - i).toFixed(decPlaces).slice(2) : "");
};


$.fn.formReset = function () {
    var $this = $(this);

    $this.find(":input").each(function () {
        switch (this.tagName) {
            case "SELECT":
                $(this).val($(this).find("option").first().attr("value"));
                break;
            default:
                $(this).val("");
        }



    });
};

function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

/**
* jQuery alterClass plugin
*
* Remove element classes with wildcard matching. Optionally add classes:
*   $( '#foo' ).alterClass( 'foo-* bar-*', 'foobar' )
*
* Copyright (c) 2011 Pete Boere (the-echoplex.net)
* Free under terms of the MIT license: http://www.opensource.org/licenses/mit-license.php
*
*/
(function ($) {

    $.fn.alterClass = function (removals, additions) {

        var self = this;

        if (removals.indexOf('*') === -1) {
            // Use native jQuery methods if there is no wildcard matching
            self.removeClass(removals);
            return !additions ? self : self.addClass(additions);
        }

        var patt = new RegExp('\\s' +
            removals.
                replace(/\*/g, '[A-Za-z0-9-_]+').
                split(' ').
                join('\\s|\\s') +
            '\\s', 'g');

        self.each(function (i, it) {
            var cn = ' ' + it.className + ' ';
            while (patt.test(cn)) {
                cn = cn.replace(patt, ' ');
            }
            it.className = $.trim(cn);
        });

        return !additions ? self : self.addClass(additions);
    };

})(jQuery);